import { useSelector } from 'react-redux'
import ContactLifeCycleSelectors from 'modules/domain/contactLifeCycle/selectors'
import { Progress, ResourceHook } from 'modules/types'
import ContactLifeCycleActions from 'modules/domain/contactLifeCycle/duck'
import { ContactLifeCycle, ContactLifeCycleListRequestFilter } from 'modules/domain/contactLifeCycle/types'
import { useAction, useDidMount, usePageQuery } from '@agro-club/frontend-shared'

export const useContactLifeCycleList: ResourceHook<
  ContactLifeCycle[],
  [{ filter?: ContactLifeCycleListRequestFilter; pageSize?: number }]
> = ({ filter, pageSize }: { filter?: ContactLifeCycleListRequestFilter; pageSize?: number } = {}) => {
  const progress = useSelector(ContactLifeCycleSelectors.listFetchProgress)
  const list = useSelector(ContactLifeCycleSelectors.contactLifeCycleList)
  const page = usePageQuery()
  const params: { filter?: ContactLifeCycleListRequestFilter; page?: number; pageSize?: number } = {}
  if (filter) params.filter = filter
  if (page) params.page = page
  if (pageSize !== undefined) params.pageSize = pageSize
  const fetchAction = useAction(ContactLifeCycleActions.listRequested, page ? { page } : {})

  useDidMount(() => {
    if (progress !== Progress.SUCCESS) {
      fetchAction()
    }
  })

  return [progress, list]
}

export const useContactLifeCycle: ResourceHook<ContactLifeCycle, [string]> = (id: string) => {
  const meta = useSelector((state) => ContactLifeCycleSelectors.meta(state, id))
  const contactLifeCycle = useSelector((state) => ContactLifeCycleSelectors.contactLifeCycle(state, id))
  const fetchAction = useAction(ContactLifeCycleActions.itemRequested, id)

  useDidMount(() => {
    if (!contactLifeCycle || contactLifeCycle.id !== id) {
      fetchAction()
    }
  })

  return [meta.fetchProgress, contactLifeCycle]
}
